import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { LegalPage } from './-components/legal-page';
import { slugs } from './cookies.meta';

export const Route = createFileRoute('/www/cookies')({
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(
			trpc.core.getLegalContent.queryOptions({ type: 'cookies', locale: context.locale }),
		);
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return (
		<LegalPage
			type="cookies"
			slugs={slugs}
			title={t`Cookies Policy - Worldcoo`}
			description={t`Which cookies Worldcoo's website uses, what each one is for and how to change your choice at any time.`}
		/>
	);
}
